// extracted by mini-css-extract-plugin
export default {"root":"iLmqPZA","form":"s40pRS4","header":"qN4icAA","footer":"eHdRuLr","input":"PKuTVIU","link":"WY577Zt","formLink":"sj3A94L"};